import type { CrmMessages } from "./englishCrmMessages";

export const spanishCrmMessages: CrmMessages = {
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nombre de la empresa",
        website: "Sitio web",
        linkedin_url: "LinkedIn",
        phone_number: "Teléfono",
        created_at: "Creada el",
        nb_contacts: "Número de contactos",
        revenue: "Facturación",
        sector: "Sector",
        size: "Tamaño",
        tax_identifier: "NIT",
        address: "Dirección",
        city: "Ciudad",
        zipcode: "Código postal",
        state_abbr: "Departamento",
        country: "País",
        description: "Descripción",
        context_links: "Enlaces de referencia",
        sales_id: "Responsable",
      },
      filters: {
        relationship: "Relación",
        prospects: "Prospectos",
        clients: "Clientes",
      },
      empty: {
        description: "Todavía no hay empresas registradas.",
        title: "No hay empresas",
      },
      import: { title: "Importar empresas" },
      field_categories: {
        contact: "Contacto",
        additional_info: "Información adicional",
        address: "Dirección",
        context: "Contexto",
      },
      action: {
        create: "Crear empresa",
        edit: "Editar empresa",
        new: "Nueva empresa",
        show: "Ver empresa",
      },
      added_on: "Agregada el %{date}",
      followed_by: "A cargo de %{name}",
      followed_by_you: "A tu cargo",
      no_contacts: "Sin contactos",
      nb_contacts: "%{smart_count} contacto |||| %{smart_count} contactos",
      nb_deals: "%{smart_count} negocio |||| %{smart_count} negocios",
      sizes: {
        one_employee: "1 empleado",
        two_to_nine_employees: "2 a 9 empleados",
        ten_to_forty_nine_employees: "10 a 49 empleados",
        fifty_to_two_hundred_forty_nine_employees: "50 a 249 empleados",
        two_hundred_fifty_or_more_employees: "250 o más empleados",
      },
      autocomplete: {
        create_error: "Ocurrió un error al crear la empresa",
        create_item: "Crear %{item}",
        create_label: "Escribe para crear una empresa nueva",
      },
    },
    clients: {
      name: "Cliente |||| Clientes",
      forcedCaseName: "Cliente",
      fields: {
        name: "Marca",
        sector: "Sector",
        website: "Sitio web",
        service_mode: "Modalidad",
        services: "Servicios contratados",
        client_since: "Cliente desde",
        sales_id: "Responsable en la agencia",
        main_contact_name: "Nombre",
        main_contact_role: "Cargo",
        main_contact_whatsapp: "WhatsApp",
        main_contact_email: "Correo",
        content_approver: "Quién aprueba el contenido",
        managed_accounts: "Cuentas que manejamos",
        client_notes: "Notas (gustos, cosas a evitar, acuerdos)",
      },
      service_modes: {
        full_content: "Contenido completo",
        creative_direction: "Solo dirección creativa",
      },
      sections: {
        contact: "Contacto principal",
        service: "Servicio",
        contract: "Contrato",
        accounts: "Cuentas que manejamos",
        notes: "Notas",
        portal: "Acceso al portal",
      },
      action: {
        convert: "Convertir en cliente",
        converted: "La empresa ahora es cliente",
        edit: "Editar ficha",
        view_profile: "Ver ficha 360",
      },
      empty: {
        title: "Todavía no hay clientes",
        description:
          'Abre una empresa y haz clic en "Convertir en cliente" para crear su ficha.',
      },
      contract: {
        monthly_fee: "Valor mensual",
        start_date: "Inicio del contrato",
        notes: "Notas del contrato",
        empty: "Aún no hay valor de contrato registrado",
        saved: "Contrato guardado",
        per_month: "al mes",
        admin_only: "Solo los administradores ven esta sección.",
      },
      accounts: {
        platform: "Plataforma",
        handle: "Cuenta o enlace",
        notes: "Notas",
        empty: "Aún no hay cuentas registradas",
        no_passwords: "Nunca guardes contraseñas aquí.",
      },
      portal: {
        coming_soon:
          "La invitación del cliente al portal llega en el siguiente paso.",
      },
      not_set: "Sin definir",
      nb_services: "%{smart_count} servicio |||| %{smart_count} servicios",
    },
    content_pieces: {
      undated:
        "Sin fecha de publicación: %{smart_count} pieza |||| Sin fecha de publicación: %{smart_count} piezas",
      name: "Pieza |||| Piezas",
      calendar: "Calendario de contenido",
      menu: "Calendario",
      all_clients: "Todos los clientes",
      fields: {
        title: "Título",
        company_id: "Cliente",
        format: "Formato",
        publish_date: "Fecha de publicación",
        due_date: "Entrega interna",
        assignee_id: "Responsable",
        script: "Guion o indicación creativa",
        caption: "Texto de publicación",
        status: "Estado",
      },
      formats: {
        reel: "Reel",
        post: "Post",
        carousel: "Carrusel",
        story: "Historia",
        video: "Video",
        other: "Otro",
      },
      statuses: {
        preparing: "En preparación",
        in_review: "Por aprobar",
        changes_requested: "Con cambios",
        approved: "Aprobada",
        published: "Publicada",
      },
      stats: {
        total: "Piezas del mes",
      },
      filters: {
        all: "Todas",
      },
      action: {
        new: "Nueva pieza",
        edit: "Editar pieza",
        send_to_review: "Enviar al cliente para aprobar",
        resend_to_review: "Enviar nueva versión a aprobar",
        mark_published: "Marcar como publicada",
        back_to_preparing: "Volver a preparación",
        add_version: "Agregar versión",
        delete: "Eliminar pieza",
      },
      versions: {
        title: "Versiones",
        version: "Versión %{number}",
        empty: "Aún no hay archivo ni enlace",
        upload: "Subir archivos (imágenes, videos o PDF)",
        link: "O pega un enlace (Drive, YouTube, Canva...)",
        note: "Qué cambió (opcional)",
        save: "Guardar versión",
        need_file_or_link: "Agrega un archivo o un enlace",
        too_large: "El archivo pesa más de 50 MB. Usa un enlace de Drive.",
        open: "Abrir",
        open_link: "Abrir el enlace",
        previous: "Anterior",
        next: "Siguiente",
        more: "más",
        less: "menos",
        upload_hint:
          "Para un carrusel, elige varios archivos a la vez: se muestran en ese orden. Máximo 50 MB por archivo.",
        uploading: "Subiendo...",
        open_in_drive: "Abrir en Drive",
        open_in_youtube: "Abrir en YouTube",
        open_in_canva: "Abrir en Canva",
        share_hint: "Si no se ve, el archivo debe estar compartido como 'Cualquier persona con el enlace'.",
      },
      comments: {
        title: "Comentarios",
        empty: "Aún no hay comentarios",
        placeholder: "Escribe un comentario...",
        send: "Enviar",
        client: "Cliente",
      },
      approved_by: "Aprobada por %{name}",
      select_client: "Elige un cliente para crear piezas",
      no_selection: "Selecciona una pieza del calendario para ver su detalle.",
      saved: "Pieza guardada",
      deleted: "Pieza eliminada",
      delete_confirm: "¿Eliminar esta pieza con sus versiones y comentarios?",
      no_clients:
        "Todavía no hay clientes. Convierte una empresa en cliente para planear su contenido.",
      no_pieces_day: "No hay piezas este día.",
      weekdays: "Lun,Mar,Mié,Jue,Vie,Sáb,Dom",
    },
    client_reports: {
      name: "Informe |||| Informes",
      menu: "Informes",
      title: "Informes mensuales",
      empty: "Todavía no hay informes publicados.",
      add: "Publicar informe",
      kind: "Área",
      kinds: {
        content: "Contenido y redes",
        paid_media: "Pauta digital",
        web: "Web",
        general: "General",
      },
      month: "Mes",
      summary: "Resumen en una línea (qué pasó este mes)",
      file: "Archivo del informe (PDF o imagen)",
      link: "O pega un enlace (Drive, Looker Studio...)",
      need_file_or_link: "Agrega un archivo o un enlace",
      saved: "Informe publicado",
      open: "Abrir informe",
      delete_confirm: "¿Eliminar este informe?",
    },
    brand_assets: {
      menu: "Mi marca",
      title: "Su marca",
      empty: "Todavía no hay material de marca.",
      add: "Agregar material de marca",
      kind: "Tipo",
      label: "Nombre",
      value_color: "Código del color (#2F6BFF)",
      value_font: "Nombre de la tipografía",
      value_other: "Nota (opcional)",
      file: "Archivo (logo, PDF, imagen)",
      link: "O pega un enlace",
      saved: "Material de marca guardado",
      copied: "Copiado",
      open: "Abrir",
      delete_confirm: "¿Eliminar este elemento?",
      kinds: {
        logo: "Logos",
        color: "Colores",
        font: "Tipografías",
        manual: "Manual de marca",
        brief: "Brief",
        photo: "Fotos",
        other: "Otros",
      },
    },
    proposals: {
      name: "Propuesta |||| Propuestas",
      menu: "Propuestas",
      empty: "Todavía no hay propuestas.",
      create: "Crear propuesta",
      edit: "Editar propuesta",
      view_pdf: "Ver y descargar PDF",
      download_pdf: "Descargar PDF",
      back: "Volver",
      saved: "Propuesta guardada",
      deleted: "Propuesta eliminada",
      delete_confirm: "¿Eliminar esta propuesta?",
      fields: {
        title: "Título de la propuesta",
        company_id: "Empresa",
        status: "Estado",
        intro: "Introducción",
        items: "Servicios",
        service: "Servicio",
        description: "Qué incluye",
        monthly_price: "Valor mensual",
        setup_fee: "Valor único de arranque (opcional)",
        valid_until: "Vigente hasta",
        terms: "Condiciones",
      },
      statuses: {
        draft: "Borrador",
        sent: "Enviada",
        accepted: "Aceptada",
        rejected: "Rechazada",
      },
      add_item: "Agregar servicio",
      monthly_total: "Total mensual",
      setup: "Arranque",
      default_title: "Propuesta para %{company}",
      default_intro:
        "Esta propuesta reúne los servicios que conversamos para %{company}, con lo que incluye cada uno y su valor mensual.",
      default_terms:
        "Los valores no incluyen la inversión en pauta, que se paga directamente a las plataformas.\nSin contratos de permanencia.",
      document: {
        heading: "Propuesta comercial",
        prepared_for: "Preparada para",
        attention: "Atención:",
        date: "Fecha de emisión",
        valid_until: "Válida hasta",
        service: "Servicio",
        monthly_value: "Valor mensual",
        subtotal: "Subtotal mensual",
        setup: "Implementación (pago único)",
        total: "Total mensual",
        terms: "Condiciones",
        acceptance: "Aceptación",
        acceptance_text: "Con la firma de este documento, ambas partes aceptan los servicios, valores y condiciones descritos.",
        sign_for: "Por %{name}",
        sign_fields: "Nombre, firma y fecha",
        contact: "CMG360 · Medellín, Colombia",
      },
    },
    contacts: {
      name: "Contacto |||| Contactos",
      forcedCaseName: "Contacto",
      field_categories: {
        background_info: "Contexto",
        identity: "Identidad",
        misc: "Otros",
        personal_info: "Datos de contacto",
        position: "Cargo",
      },
      fields: {
        first_name: "Nombre",
        last_name: "Apellido",
        last_seen: "Última actividad",
        title: "Cargo",
        company_id: "Empresa",
        email_jsonb: "Correos",
        email: "Correo",
        phone_jsonb: "Teléfonos",
        phone_number: "Teléfono",
        linkedin_url: "LinkedIn",
        background: "Contexto (cómo lo conocimos, notas, etc.)",
        has_newsletter: "Recibe boletín",
        sales_id: "Responsable",
      },
      action: {
        add: "Agregar contacto",
        add_first: "Agrega tu primer contacto",
        create: "Crear contacto",
        edit: "Editar contacto",
        export_vcard: "Exportar a vCard",
        new: "Nuevo contacto",
        show: "Ver contacto",
      },
      background: {
        last_activity_on: "Última actividad el %{date}",
        added_on: "Agregado el %{date}",
        followed_by: "A cargo de %{name}",
        followed_by_you: "A tu cargo",
        status_none: "Ninguno",
      },
      position_at: "%{title} en",
      position_at_company: "%{title} en %{company}",
      empty: {
        description: "Todavía no hay contactos registrados.",
        title: "No hay contactos",
      },
      import: { title: "Importar contactos" },
      inputs: {
        genders: { male: "Él", female: "Ella", nonbinary: "Elle" },
        personal_info_types: {
          work: "Trabajo",
          home: "Personal",
          other: "Otro",
        },
      },
      list: { error_loading: "Error al cargar los contactos" },
      bulk_tag: {
        action: "Etiquetar",
        back: "Volver a etiquetas",
        create_description:
          "Crea una etiqueta nueva y aplícala a los contactos seleccionados.",
        description:
          "Elige una etiqueta existente o crea una nueva para los contactos seleccionados.",
        empty: "Aún no hay etiquetas. Crea una para etiquetar los contactos.",
        error: "No se pudo etiquetar a los contactos",
        noop: "Los contactos seleccionados ya tienen esta etiqueta",
        success:
          "Etiqueta agregada a %{smart_count} contacto |||| Etiqueta agregada a %{smart_count} contactos",
        title: "Etiquetar contactos",
      },
      merge: {
        action: "Unir con otro contacto",
        confirm: "Unir contactos",
        current_contact: "Contacto actual (se eliminará)",
        description: "Une este contacto con otro.",
        error: "No se pudieron unir los contactos",
        merging: "Uniendo...",
        no_additional_data: "No hay datos adicionales para unir",
        select_target: "Elige el contacto con el que se va a unir",
        success: "Contactos unidos",
        target_contact: "Contacto destino (se conserva)",
        title: "Unir contacto",
        warning_description:
          "Toda la información pasará al segundo contacto. No se puede deshacer.",
        warning_title: "Atención: esta acción no se puede deshacer",
        what_will_be_merged: "Qué se va a unir:",
      },
      filters: {
        all_statuses: "Todos",
        before_last_month: "Antes del mes pasado",
        before_this_month: "Antes de este mes",
        before_this_week: "Antes de esta semana",
        managed_by_me: "A mi cargo",
        search: "Buscar nombre, empresa...",
        this_week: "Esta semana",
        today: "Hoy",
        tags: "Etiquetas",
        tasks: "Tareas",
      },
      hot: {
        empty_change_status:
          'Cambia el estado de un contacto agregándole una nota y haciendo clic en "Mostrar opciones".',
        empty_hint: 'Aquí aparecen los contactos con estado "caliente".',
        title: "Contactos calientes",
      },
    },
    deals: {
      name: "Negocio |||| Negocios",
      fields: {
        name: "Nombre",
        description: "Descripción",
        company_id: "Empresa",
        contact_ids: "Contactos",
        category: "Categoría",
        services: "Servicios",
        amount: "Valor",
        expected_closing_date: "Fecha estimada de cierre",
        stage: "Etapa",
      },
      action: {
        back_to_deal: "Volver al negocio",
        create: "Crear negocio",
        new: "Nuevo negocio",
      },
      field_categories: { misc: "Otros" },
      filters: { only_mine: "Solo los míos" },
      archived: {
        action: "Archivar",
        error: "No se pudo archivar el negocio",
        list_title: "Negocios archivados",
        success: "Negocio archivado",
        title: "Negocio archivado",
        view: "Ver negocios archivados",
      },
      inputs: { linked_to: "Relacionado con" },
      unarchived: {
        action: "Devolver al tablero",
        error: "No se pudo restaurar el negocio",
        success: "Negocio restaurado",
      },
      updated: "Negocio actualizado",
      empty: {
        before_create: "antes de crear un negocio.",
        description: "Todavía no hay negocios registrados.",
        title: "No hay negocios",
      },
      import: { title: "Importar negocios" },
      invalid_date: "Fecha inválida",
    },
    notes: {
      name: "Nota |||| Notas",
      forcedCaseName: "Nota",
      fields: {
        status: "Estado",
        date: "Fecha",
        attachments: "Adjuntos",
        contact_id: "Contacto",
        deal_id: "Negocio",
      },
      action: {
        add: "Agregar nota",
        add_first: "Agrega tu primera nota",
        delete: "Eliminar nota",
        edit: "Editar nota",
        update: "Actualizar nota",
        add_this: "Agregar esta nota",
      },
      sheet: {
        create: "Crear nota",
        create_for: "Crear nota para %{name}",
        edit: "Editar nota",
        edit_for: "Editar nota de %{name}",
      },
      deleted: "Nota eliminada",
      empty: "Todavía no hay notas",
      author_added: "%{name} agregó una nota",
      you_added: "Agregaste una nota",
      me: "Yo",
      list: { error_loading: "Error al cargar las notas" },
      note_for_contact: "Nota para %{name}",
      stepper: { hint: "Entra a un contacto y agrégale una nota" },
      added: "Nota agregada",
      inputs: {
        add_note: "Agrega una nota",
        options_hint: "(adjunta archivos o cambia detalles)",
        show_options: "Mostrar opciones",
      },
      actions: { attach_document: "Adjuntar documento" },
      validation: {
        note_or_attachment_required: "Escribe una nota o adjunta un archivo",
      },
    },
    sales: {
      delete: {
        button: "Eliminar usuario",
        title: "¿Eliminar a %{name}?",
        description:
          "Su cuenta se borra y no podrá volver a entrar. Sus contactos, negocios, tareas y notas pasan a tu nombre. Esta acción no se puede deshacer.",
        confirm: "Sí, eliminar",
        success: "Usuario eliminado",
        error: "No se pudo eliminar el usuario",
      },
      name: "Usuario |||| Usuarios",
      fields: {
        first_name: "Nombre",
        last_name: "Apellido",
        email: "Correo",
        secondary_email: "Correo secundario",
        secondary_emails: "Correos secundarios",
        administrator: "Administrador",
        disabled: "Desactivado",
      },
      create: {
        link_ready: "Enlace de acceso listo para %{name}",
        link_hint:
          "Envíaselo por WhatsApp. Sirve una sola vez y con él elige su contraseña. Si se vence, entra a ese usuario y crea un enlace nuevo.",
        copy: "Copiar enlace",
        send_whatsapp: "Enviar por WhatsApp",
        done: "Listo",
        whatsapp_message:
          "¡Hola, %{name}! Este es tu acceso a la plataforma de CMG360: %{link}",
        error: "Ocurrió un error al crear el usuario.",
        success:
          "Usuario creado. Pronto recibirá un correo para crear su contraseña.",
        title: "Crear un usuario",
      },
      edit: {
        new_access_link: "Crear nuevo enlace de acceso",
        error: "Ocurrió un error. Intenta de nuevo.",
        record_not_found: "No se encontró el registro",
        success: "Usuario actualizado",
        title: "Editar a %{name}",
      },
      action: { new: "Nuevo usuario" },
    },
    tasks: {
      name: "Tarea |||| Tareas",
      forcedCaseName: "Tarea",
      fields: {
        text: "Descripción",
        due_date: "Fecha límite",
        type: "Tipo",
        contact_id: "Contacto",
        due_short: "vence",
      },
      action: {
        add: "Agregar tarea",
        create: "Crear tarea",
        edit: "Editar tarea",
      },
      actions: {
        postpone_next_week: "Pasar a la próxima semana",
        postpone_tomorrow: "Pasar a mañana",
        title: "acciones de la tarea",
      },
      added: "Tarea agregada",
      deleted: "Tarea eliminada",
      dialog: { create: "Crear tarea", create_for: "Crear tarea para %{name}" },
      sheet: { edit: "Editar tarea", edit_for: "Editar tarea de %{name}" },
      empty: "Todavía no hay tareas",
      empty_list_hint: "Aquí aparecen las tareas de tus contactos.",
      filters: {
        later: "Más adelante",
        overdue: "Vencidas",
        this_week: "Esta semana",
        today: "Hoy",
        tomorrow: "Mañana",
        with_pending: "Con tareas pendientes",
      },
      regarding_contact: "(Sobre: %{name})",
      updated: "Tarea actualizada",
    },
    tags: {
      name: "Etiqueta |||| Etiquetas",
      action: { add: "Agregar etiqueta", create: "Crear etiqueta" },
      dialog: {
        color: "Color",
        create_title: "Crear una etiqueta",
        edit_title: "Editar etiqueta",
        name_label: "Nombre de la etiqueta",
        name_placeholder: "Escribe el nombre",
      },
      empty: "Todavía no hay etiquetas.",
    },
  },
  crm: {
    action: { reset_password: "Restablecer contraseña" },
    auth: {
      no_access: "Esta cuenta ya no tiene acceso a la plataforma.",
      first_name: "Nombre",
      last_name: "Apellido",
      confirm_password: "Confirmar contraseña",
      confirmation_required:
        "Abre el enlace que te enviamos por correo para confirmar tu cuenta.",
      recovery_email_sent:
        "Si tienes una cuenta, pronto recibirás un correo para recuperar tu contraseña.",
      sign_in_failed: "No se pudo iniciar sesión.",
      sign_in_google_workspace: "Entrar con Google",
      signup: {
        create_account: "Crear cuenta",
        create_first_user:
          "Crea la primera cuenta, la del administrador, para terminar la configuración.",
        creating: "Creando...",
        initial_user_created: "Cuenta de administrador creada",
      },
      errors: {
        password_requirements:
          "La contraseña necesita al menos una letra minúscula, una mayúscula y un número.",
        password_too_short:
          "La contraseña debe tener al menos %{min} caracteres.",
        same_password: "La nueva contraseña debe ser distinta a la anterior.",
        invalid_credentials: "Correo o contraseña incorrectos.",
        email_not_confirmed: "Este correo todavía no está confirmado.",
        link_expired:
          "Este enlace de acceso ya venció o ya se usó. Pide uno nuevo a la agencia.",
        rate_limited:
          "Demasiados intentos. Espera unos minutos y vuelve a intentar.",
      },
      welcome_title: "Bienvenido a CMG360",
    },
    common: {
      account_manager: "Responsable",
      activity: "Actividad",
      added: "agregó",
      details: "Detalles",
      last_activity_with_date: "última actividad %{date}",
      load_more: "Cargar más",
      misc: "Otros",
      past: "Pasadas",
      read_more: "Leer más",
      retry: "Reintentar",
      show_less: "Ver menos",
      copied: "¡Copiado!",
      copy: "Copiar",
      loading: "Cargando...",
      me: "Yo",
      task_count: "%{smart_count} tarea |||| %{smart_count} tareas",
    },
    changelog: { title: "Novedades" },
    activity: {
      added_company: "%{name} agregó la empresa",
      you_added_company: "Agregaste la empresa",
      added_contact: "%{name} agregó a",
      you_added_contact: "Agregaste a",
      added_note: "%{name} agregó una nota sobre",
      you_added_note: "Agregaste una nota sobre",
      added_note_about_deal: "%{name} agregó una nota sobre el negocio",
      you_added_note_about_deal: "Agregaste una nota sobre el negocio",
      added_deal: "%{name} agregó el negocio",
      you_added_deal: "Agregaste el negocio",
      at_company: "en",
      to: "a",
      load_more: "Cargar más actividad",
    },
    dashboard: {
      deals_chart: "Ingresos esperados de negocios",
      deals_pipeline: "Embudo de negocios",
      latest_activity: "Actividad reciente",
      latest_activity_error: "Error al cargar la actividad reciente",
      latest_notes: "Mis últimas notas",
      latest_notes_added_ago: "agregada %{timeAgo}",
      stepper: {
        install: "Instalar la plataforma",
        progress: "%{step}/3 listos",
        whats_next: "¿Qué sigue?",
      },
      upcoming_tasks: "Próximas tareas",
    },
    data_import: {
      button: "Importar CSV",
      complete:
        "Importación terminada. Se importaron %{importCount} registros con %{errorCount} errores",
      csv_file: "Archivo CSV",
      error: "No se pudo importar el archivo. Verifica que sea un CSV válido.",
      in_progress: "Importando…",
      progress:
        "Importados %{importCount} / %{rowCount} registros, con %{errorCount} errores.",
      remaining_time: "Tiempo restante estimado:",
      resource: "Tipo de dato",
      sample_download: "Descargar CSV de ejemplo",
      sample_hint: "Este archivo de ejemplo te sirve como plantilla",
      start: "Empezar importación",
      stop: "Detener importación",
      stopped:
        "Importación detenida. Se importaron %{importCount} registros con %{errorCount} errores",
      title: "Importar datos",
    },
    header: { import_data: "Importar desde JSON" },
    image_editor: {
      change: "Cambiar",
      drop_hint: "Arrastra un archivo para subirlo o haz clic para elegirlo.",
      editable_content: "Contenido editable",
      title: "Subir y ajustar imagen",
      update_image: "Actualizar imagen",
    },
    import: {
      action: {
        download_error_report: "Descargar el reporte de errores",
        import: "Importar",
        import_another: "Importar otro archivo",
      },
      error: { unable: "No se pudo importar este archivo." },
      idle: {
        description_1:
          "Puedes importar usuarios, empresas, contactos, notas y tareas.",
        description_2:
          "Los datos deben venir en un archivo JSON como este ejemplo:",
      },
      status: {
        all_success: "Todos los registros se importaron.",
        complete: "Importación terminada.",
        failed: "Fallidos",
        imported: "Importados",
        in_progress: "Importando, no salgas de esta página.",
        some_failed: "Algunos registros no se importaron.",
        table_caption: "Estado de la importación",
      },
      title: "Importar desde JSON",
    },
    settings: {
      about: "Acerca de",
      companies: { sectors: "Sectores" },
      dark_mode_logo: "Logo para modo oscuro",
      deals: {
        categories: "Categorías",
        currency: "Moneda",
        pipeline_help: "Elige qué etapas cuentan como negocios en curso.",
        pipeline_statuses: "Etapas en curso",
        stages: "Etapas",
      },
      light_mode_logo: "Logo para modo claro",
      notes: { statuses: "Estados" },
      reset_defaults: "Restablecer valores",
      save_error: "No se pudo guardar la configuración",
      saved: "Configuración guardada",
      saving: "Guardando...",
      tasks: { types: "Tipos" },
      preferences: "Preferencias",
      title: "Ajustes",
      app_title: "Nombre de la plataforma",
      sections: { branding: "Marca" },
      validation: {
        duplicate: "%{display_name} repetidas: %{items}",
        in_use:
          "No se pueden quitar %{display_name} que todavía usan algunos negocios: %{items}",
        validating: "Validando…",
        entities: { categories: "categorías", stages: "etapas" },
      },
    },
    access: {
      title: "Te damos la bienvenida a CMG360",
      description: "Toca el botón para crear tu contraseña y entrar.",
      continue: "Crear mi contraseña",
      invalid: "Este enlace ya se usó o venció. Pídele uno nuevo a la agencia.",
    },
    my_work: {
      subtitle: "Esto es lo que tienes a tu cargo.",
      changes: "Cambios pedidos",
      changes_empty: "Ningún cliente te ha pedido cambios.",
      to_do: "Para hacer",
      to_do_empty: "No tienes piezas en preparación.",
      waiting: "Esperando al cliente",
      waiting_empty: "Nada pendiente de aprobación.",
      to_publish: "Publicar hoy y esta semana",
      to_publish_empty: "Nada aprobado para publicar en los próximos 7 días.",
      unassigned: "Piezas sin responsable",
      sent_today: "Enviada hoy",
      waiting_days: "Hace %{smart_count} día |||| Hace %{smart_count} días",
      today: "Hoy",
      overdue: "Atrasada",
    },
    agency_dashboard: {
      content_month:
        "Contenido del mes: %{smart_count} pieza |||| Contenido del mes: %{smart_count} piezas",
      deals_chart_hint:
        "Ganados en verde, negocios abiertos ponderados por su etapa en azul y perdidos en rojo, según el mes en que se creó el negocio.",
      greeting: "Hola, %{name}",
      subtitle: "Así va la agencia hoy.",
      in_review: "Esperando aprobación del cliente",
      changes_requested: "Cambios por hacer",
      active_clients: "Clientes activos",
      proposals_sent: "Propuestas sin respuesta",
      upcoming: "Se publica en los próximos 7 días",
      upcoming_empty: "No hay nada programado para los próximos 7 días.",
      pipeline: "Embudo comercial",
      pipeline_empty: "Todavía no hay negocios abiertos.",
      open_deals:
        "%{smart_count} negocio abierto |||| %{smart_count} negocios abiertos",
    },
    portal: {
      menu: "Mi contenido",
      greeting: "Hola, %{name}",
      subtitle: "Este es el contenido que estamos preparando para %{company}.",
      waiting_title: "Esperan tu aprobación",
      nothing_this_month: "Este mes no hay piezas para revisar.",
      no_selection: "Elige una pieza del calendario para revisarla.",
      approve: "Aprobar",
      request_changes: "Pedir cambios",
      changes_placeholder: "Cuéntanos qué cambiarías",
      send_changes: "Enviar cambios",
      comment_required: "Escribe qué cambiarías antes de enviar.",
      approved_toast: "Pieza aprobada. ¡Gracias!",
      changes_toast: "Enviamos tus comentarios al equipo.",
      waiting_hint: "Esta pieza espera tu aprobación.",
      invite: {
        title: "Invitar al portal",
        description:
          "Crea el acceso del cliente. Recibirás un enlace de un solo uso para enviarle por WhatsApp; con él elige su contraseña.",
        first_name: "Nombre",
        last_name: "Apellido",
        email: "Correo",
        create_link: "Crear enlace de acceso",
        link_ready: "Enlace de acceso listo",
        link_hint:
          "Envíaselo al cliente. Sirve una sola vez; si se vence, crea uno nuevo aquí.",
        copy: "Copiar enlace",
        copied: "Enlace copiado",
        send_whatsapp: "Enviar por WhatsApp",
        whatsapp_message:
          "¡Hola, %{name}! Este es tu acceso al portal de CMG360, donde puedes revisar y aprobar tu contenido: %{link}",
        new_link: "Nuevo enlace",
        people: "Personas con acceso",
        no_people: "Nadie de este cliente tiene acceso todavía.",
        errors: {
          email_is_staff: "Ese correo es de alguien del equipo de la agencia.",
          email_other_client: "Ese correo ya tiene acceso a otro cliente.",
          generic: "No se pudo crear el acceso. Intenta de nuevo.",
        },
      },
    },
    theme: {
      dark: "Oscuro",
      label: "Tema",
      light: "Claro",
      system: "Sistema",
    },
    language: "Idioma",
    navigation: { label: "Navegación" },
    profile: {
      add_secondary_email: "Agregar un correo",
      email_is_client: "%{email} ya es un cliente del portal. Usa otro correo para el equipo.",
      email_taken: "%{email} ya lo usa otro usuario",
      no_secondary_emails: "Ninguno",
      secondary_email_invalid: "%{email} no es un correo válido",
      secondary_email_is_primary: "%{email} ya es tu correo principal",
      secondary_email_taken: "%{email} ya lo usa otro usuario",
      too_many_secondary_emails:
        "No puedes agregar más de 10 correos secundarios",
      secondary_emails_help:
        "Otros correos desde los que escribes. Deja uno vacío para quitarlo.",
      inbound: {
        description:
          "Puedes enviar correos a la dirección de entrada del servidor, por ejemplo agregándola en el campo %{field}. La plataforma procesará los correos y los guardará como notas en los contactos.",
        title: "Correo entrante",
      },
      mcp: {
        title: "Servidor MCP",
        description:
          "Usa esta dirección para conectar tu asistente de IA a los datos de la plataforma.",
      },
      password: { change: "Cambiar contraseña" },
      password_reset_sent:
        "Te enviamos un correo para restablecer tu contraseña",
      record_not_found: "No se encontró el registro",
      title: "Perfil",
      updated: "Perfil actualizado",
      update_error: "Ocurrió un error. Intenta de nuevo",
    },
    validation: {
      invalid_url: "Debe ser una dirección web válida",
      invalid_linkedin_url: "Debe ser un enlace de linkedin.com",
    },
  },
};
